import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-number-badge',
  imports: [],
  templateUrl: './number-badge.component.html',
  styleUrl: './number-badge.component.scss'
})
export class NumberBadgeComponent {
  @Input() count = 0
}
